import { FreightconfirmationComponent } from "./freightconfirmation.component";
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { HasRightDirective } from "../_directives/has-right.directive";
import { KeysPipe } from "../_Pipes/KeyValuePipe";
import { HttpClientModule, HttpClient } from "@angular/common/http";
import {
    TranslateLoader,
    TranslateModule,
    TranslateService,
} from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { TranslateConfigService } from "../theme/home/translateConfig.service";
import { NumToWordPipe } from "../_Pipes/NumTowordPipe.pipe";
// For Translator

// AoT requires an exported function for factories
export function createTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, "./assets/translator/", ".txt");
}



@NgModule({
    imports: [
        CommonModule,
        HttpClientModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: createTranslateLoader,
                deps: [HttpClient],
            },
        }),
    ],
    declarations: [
        FreightconfirmationComponent,
        HasRightDirective,
        KeysPipe,
        NumToWordPipe
    ],
    exports: [
        FreightconfirmationComponent,
        HasRightDirective,
        KeysPipe,
        NumToWordPipe
    ],
    providers: [TranslateConfigService]
})
export class SharedModule { }
